import type { FC } from 'react';
import React from 'react';
import { useAppSelector } from '../../../app/hooks';
import getThemeLookup from '../../../selectors/getThemeLookup';
import { buildRedcatPaymentStyles } from '../utils/buildRedcatPaymentStyles';

interface RedcatPaymentCardFormStyleProps {
  readonly children: React.ReactNode;
}

export const RedcatPaymentCardFormStyle: FC<RedcatPaymentCardFormStyleProps> = ({ children }) => {
  const p = useAppSelector(getThemeLookup);
  const cardTheme = p('adyenCardField', ['color', 'backgroundColor', 'borderColor']);
  const cardFocusTheme = p('adyenCardFieldFocus', ['color', 'backgroundColor', 'borderColor']);
  const cardHoverTheme = p('adyenCardFieldHover', ['borderColor']);
  const helperTheme = p('adyenCardHelper', ['color', 'fontSize']);
  const errorTheme = p('adyenCardError', ['color', 'borderColor']);

  return (
    <>
      {buildRedcatPaymentStyles({
        cardFocusTheme,
        cardTheme,
        cardHoverTheme,
        helperTheme,
        errorTheme,
      })}
      {children}
    </>
  );
};
